var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7407 9.26862L10.2591 13.9127C9.55492 13.3161 9.12158 12.4993 9.12158 11.5906C9.12158 9.77341 10.8549 8.30493 12.9999 8.30493C14.0724 8.30493 15.0366 8.67205 15.7407 9.26862Z",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3048 5.87267C17.409 4.66118 15.2423 4.00037 12.9998 4.00037C9.17566 4.00037 5.6115 5.90938 3.13066 9.21345C2.15566 10.5075 2.15566 12.6827 3.13066 13.9768C3.9865 15.1149 4.98316 16.0969 6.0665 16.8862",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12158 18.5015C10.3566 18.9421 11.6674 19.1807 12.9999 19.1807C16.8241 19.1807 20.3882 17.2717 22.8691 13.9676C23.8441 12.6735 23.8441 10.4984 22.8691 9.20426C22.5116 8.72701 22.1216 8.27729 21.7207 7.8551",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8026 12.233C16.5209 13.5271 15.2751 14.5826 13.7476 14.8212",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/openEyeIcon.9df05828af5d38dcd61c59ac091aa871.svg";
export { ForwardRef as ReactComponent };